"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useHomeLocation = exports.useCachedSelf = exports.useRefreshSelf = exports.useSelfMaybe = exports.useSelf = exports.SelfContext = void 0;
var react_1 = __importDefault(require("react"));
var cache_1 = require("./cache");
exports.SelfContext = react_1["default"].createContext(null);
var useSelf = function () {
    var _a;
    var data = (_a = react_1["default"].useContext(exports.SelfContext)) === null || _a === void 0 ? void 0 : _a.data;
    if (data == null) {
        throw new Error("useSelf called outside SelfProvider");
    }
    return data.self;
};
exports.useSelf = useSelf;
var useSelfMaybe = function () {
    var _a, _b, _c;
    return (_c = (_b = (_a = react_1["default"].useContext(exports.SelfContext)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.self) !== null && _c !== void 0 ? _c : null;
};
exports.useSelfMaybe = useSelfMaybe;
var useRefreshSelf = function () { var _a, _b; return (_b = (_a = react_1["default"].useContext(exports.SelfContext)) === null || _a === void 0 ? void 0 : _a.refresh) !== null && _b !== void 0 ? _b : null; };
exports.useRefreshSelf = useRefreshSelf;
var useCachedSelf = function () {
    var Cache = (0, cache_1.useCache)();
    var _a = react_1["default"].useState(Cache.getPreloaded("self")), cachedValue = _a[0], setCachedValue = _a[1];
    react_1["default"].useEffect(function () {
        void Cache.get("self").then(function (v) {
            setCachedValue(v);
        });
    }, []);
    return cachedValue;
};
exports.useCachedSelf = useCachedSelf;
var useHomeLocation = function () {
    var _a;
    var data = (_a = react_1["default"].useContext(exports.SelfContext)) === null || _a === void 0 ? void 0 : _a.data;
    if (data == null) {
        throw new Error("useSelf called outside SelfProvider");
    }
    return data.homeLocation;
};
exports.useHomeLocation = useHomeLocation;
